module.exports = __webpack_public_path__ + "img/Map.7c621a04.svg";